import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import graphql from 'graphql';

export default function Template({ data }) {
  const { markdownRemark: post } = data;
  return (
    <div>
      <Helmet title={`${post.frontmatter.title} | ${data.site.siteMetadata.title}`} />
      <section>
        <div>
          <h1>{post.frontmatter.title}</h1>
        </div>
      </section>
    </div>
  );
}

Template.propTypes = {
  data: PropTypes.object,
};

export const BannerQuery = graphql`
  query banner($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        title
        header
        button
        personName
        personRole
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/banner.js